import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { bankAccountsApi } from '../../services/webApi';

const BankaHesap = () => {
  const [copiedIban, setCopiedIban] = useState('');
  const [bankAccounts, setBankAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    // Initialize AOS
    const initAOS = () => {
      if (window.AOS) {
        window.AOS.init();
      }
    };

    // Initialize Lucide Icons - Manuel yaklaşım
    const initLucide = () => {
      const createIcons = () => {
        if (window.lucide && window.lucide.createIcons) {
          console.log('Creating Lucide icons manually...');
          try {
            window.lucide.createIcons();
            console.log('Icons created successfully');
          } catch (error) {
            console.error('Error creating icons:', error);
          }
        } else {
          console.log('Lucide not ready, retrying...');
          setTimeout(createIcons, 200);
        }
      };
      
      createIcons();
    };

    // Fetch bank accounts from API
    const fetchBankAccounts = async () => {
      try {
        const response = await bankAccountsApi.getAll();
        if (isMounted && response.data.success) {
          setBankAccounts(response.data.data);
        } else if (isMounted) {
          setError('Veriler yüklenemedi');
        }
      } catch (err) {
        console.error('Bank accounts fetch error:', err);
        if (isMounted) {
          setError('Veriler yüklenirken hata oluştu');
          // Fallback to static data
          setBankAccounts([
            {
              id: 1,
              bank_name: 'Garanti Bankası',
              account_name: 'Kalem Web Yazılım Ltd. Şti.',
              iban: 'TR32 0006 2000 4350 0006 2905 54',
              currency: 'TRY',
              is_active: true,
              sort_order: 1
            },
            {
              id: 2,
              bank_name: 'VakıfBank',
              account_name: 'Kalem Web Yazılım Ltd. Şti.',
              iban: 'TR08 0001 5001 5800 7326 9299 12',
              currency: 'TRY',
              is_active: true,
              sort_order: 2
            },
            {
              id: 3,
              bank_name: 'Enpara.com',
              account_name: 'Kalem Web Yazılım Ltd. Şti.',
              iban: 'TR67 0015 7000 0000 0136 8852 15',
              currency: 'TRY',
              is_active: true,
              sort_order: 3
            }
          ]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Hemen başlat
    initAOS();
    fetchBankAccounts();
    
    // İkonları biraz sonra oluştur
    setTimeout(() => {
      initLucide();
    }, 1000);

    return () => {
      isMounted = false;
    };
  }, []);

  const copyToClipboard = async (iban) => {
    try {
      await navigator.clipboard.writeText(iban);
      setCopiedIban(iban);
      
      toast.success('IBAN kopyalandı!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      setTimeout(() => setCopiedIban(''), 2000);
    } catch (err) {
      console.error('Kopyalama hatası:', err);
      toast.error('IBAN kopyalanamadı. Lütfen manuel olarak kopyalayın.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };



  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Banka Hesap Bilgileri</span>
                    <br />Ödeme Bilgileri
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius hizmetlerimiz için ödeme yapabileceğiniz banka hesap bilgileri ve ödeme yöntemleri.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bank Accounts */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Banka Hesaplarımız</h2>
              <p className="text-sm text-default-200 font-medium">Ödeme yapabileceğiniz banka hesap bilgileri</p>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <p className="text-default-400 mt-4">Banka hesapları yükleniyor...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500">{error}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6">
              {bankAccounts.map((account, accountIndex) => (
                <div 
                  key={account.id}
                  className="group p-6 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40 border border-white/10"
                  data-aos="fade-up" 
                  data-aos-easing="ease" 
                  data-aos-duration="1000"
                  data-aos-delay={accountIndex * 100}
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-medium text-white">{account.bank_name}</h3>
                    <div className="h-10 w-10 flex items-center justify-center rounded-lg bg-primary/20 text-primary">
                      <i data-lucide="building" className="h-5 w-5"></i>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-xs font-medium text-default-400 mb-2">Hesap Sahibi</label>
                      <p className="text-sm text-default-200 font-medium">{account.account_holder}</p>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium text-default-400 mb-2">IBAN - {account.currency}</label>
                      <div className="flex items-center justify-between bg-white/5 rounded-lg p-3 border border-white/10">
                        <p className="text-sm text-default-200 font-mono break-all flex-1 mr-3">{account.iban}</p>
                        <button
                          onClick={() => copyToClipboard(account.iban)}
                          className="flex-shrink-0 p-2 rounded-lg bg-primary/20 text-primary hover:bg-primary hover:text-white transition-all duration-300"
                          title="IBAN'ı Kopyala"
                        >
                          {copiedIban === account.iban ? (
                            <i data-lucide="check" className="h-4 w-4"></i>
                          ) : (
                            <i data-lucide="copy" className="h-4 w-4"></i>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BankaHesap;
